import { useIntl } from 'react-intl';

import { KB_BASE_URL } from '@/shared/config';
import { useAppSelector } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';
import { Icon } from '@/shared/ui';

import { organizationModel } from '@/entities/organization';

import { i18n as kbI18n } from '@/widgets/KnowledgeBase/config';
import { getKbMarket } from '@/widgets/KnowledgeBase/lib';
import {
  openKnowledgeBase,
  useKbAvailability,
} from '@/widgets/KnowledgeBase/model';

import { ICON_SIZE, MOBILE_ICON_SIZE } from '../../config';

import styles from './LearningHub.module.scss';

type LearningHubProps = {
  isMobile?: boolean;
};

export const LearningHub = (props: LearningHubProps) => {
  const intl = useIntl();
  const { isFDA, isFDA3DGPRestrictions } = useAppSelector(
    organizationModel.selectors.selectFDAEnvironment,
  );
  // null while the availability probe is in flight.
  const isAvailable = useKbAvailability();

  // No hub configured, a cluster without a KB market, or the content
  // service not answering: the entry stays hidden rather than dead-ending.
  if (
    !KB_BASE_URL ||
    !getKbMarket(isFDA || isFDA3DGPRestrictions) ||
    !isAvailable
  ) {
    return null;
  }

  return (
    <button
      type="button"
      className={styles.studyIcon}
      data-component="learning-hub-link"
      onClick={() => {
        trackEvent({
          eventName: 'AllPagesKnowledgeBaseIconClicked',
        });

        openKnowledgeBase();
      }}
      aria-label={intl.formatMessage(kbI18n.open)}
    >
      <Icon name="study" size={props.isMobile ? MOBILE_ICON_SIZE : ICON_SIZE} />
    </button>
  );
};
